import type { AppThunk } from 'state';
import type { DataCity } from 'common/dataService/types/countriesTypes';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import fetchDataCities from './fetchDataCities';
import getDataCities from '../selectors/getDataCities';
import getDataCitiesCountryCode from '../selectors/getDataCitiesCountryCode';

function loadDataCities(countryCode: string): AppThunk<DataCity[] | []> {
  return async function loadDataCitiesThunk(dispatch, getState) {
    try {
      let state = getState();
      let dataCities = getDataCities(state);
      const { fetching } = state.dataService.dataCities;
      const selectedCountryCode = getDataCitiesCountryCode(state);

      if (fetching === FetchingStatus.Succeeded && selectedCountryCode === countryCode) {
        return dataCities;
      }

      await dispatch(fetchDataCities(countryCode));

      state = getState();
      dataCities = getDataCities(state);

      if (
        state.dataService.dataCities.fetching === FetchingStatus.Succeeded &&
        getDataCitiesCountryCode(state) === countryCode
      ) {
        return dataCities;
      }
    } catch (error) {
      window.Rollbar.error(error as Error);
    }

    return [];
  };
}

export default loadDataCities;
